import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { UtilityMessageComponent } from '../../../add-to-event-ui';
import { IUserNotification, UtilityMessageConfig } from '../../models/misc/misc';
import { AppState } from '../../state';
import { fromApplicationActions } from '../../state/actions/application/application.actions';
import { NotificationListComponent } from '../notification-list/notification-list.component';

@Component({
    selector: 'app-notifications-sidebar',
    templateUrl: './notifications-sidebar.component.html',
    styleUrls: ['./notifications-sidebar.component.scss'],
    imports: [CommonModule, UtilityMessageComponent, NotificationListComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationsSidebarComponent {
  @Input() notifications: IUserNotification[];

  config: UtilityMessageConfig = {
    iconClass: '!tw-size-[100px]',
    titleClass: '!tw-text-base',
    messageClass: '!tw-text-sm',
    class: 'tw-text-center',
    data: {
      icon: 'calendar-alert-v3',
      message: `We'll notify you here of anything you need to know, for instance when an organiser invites you to quote on their event.`,
      title: `You're all caught up!`
    }
  };
  constructor(private _store: Store<AppState>) {}

  closeNotificationsMenu() {
    this._store.dispatch(new fromApplicationActions.ToggleShowingNotificationsMenu(false));
  }
}
